import "./congratulationscreen.css";
import { confetti } from "@tsparticles/confetti";
import { useEffect, useState, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import particles from "../../images/confetti-bg2.png";
import { LanguageContext } from "../../context/language/LanguageContext";
import InstagramShareButton from "./components/InstagramShareButton";
import TwitterShareButton from "./components/TwitterShareButton";
import { isMobile } from 'react-device-detect';

export default function CongratulationScreen(props) {

    const { language } = useContext(LanguageContext);
    const { state } = useLocation();
    const { reward, chances, campaignId, congratsImage, tnxId, imageUrl } = state;

    const navigate = useNavigate();
    const [particleStyled, setParticleStyled] = useState(null);
    const [imageShow, setImageShow] = useState(false);

    const defaults = { startVelocity: 80, spread: 30, ticks: 160, zIndex: -9999 };

    const confettiFire = () => {
        const particleCount = 100;

        // since particles fall down, start a bit higher than random
        confetti(
            Object.assign({}, defaults, {
                particleCount,
                origin: { x: 0, y: isMobile ? 0.3 : 0.5 },
                colors: ["#FFC100", "#002ED0"],
                angle: 15,
            })
        );
        confetti(
            Object.assign({}, defaults, {
                particleCount,
                origin: { x: 1, y: isMobile ? 0.3 : 0.5 },
                colors: ["#FFC100", "#002ED0"],
                angle: 150,
            })
        );
    }

    const particleStyle = {
        backgroundImage: `url(${particles})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat'
    }

    useEffect(() => {
        setTimeout(function () {
            confettiFire();
            setImageShow(true);
        }, 2000);
        setParticleStyled(particleStyle);
    }, [])

    const onSpin = () => {
        navigate(`/visa-japan/gamification`, { state: { campaignId: campaignId } });
    }

    return <div style={{ minHeight: '100vlh', zIndex: 99 }}>
        <div style={imageShow ? particleStyled : null} className="align-center">
            <div className="row">
                <div style={{ marginTop: '50px' }} className="col-md-12">
                    <div className="row">
                        <div className="col-md-4"></div>
                        <div className="col-md-4" style={{ fontWeight: 'bolder' }}>
                            <h5 style={{ marginRight: "70px", fontSize: '32px' }}>{language?.static_labels.congratulations}</h5>
                            <h2 style={{ fontWeight: 'bolder', color: 'blue' }}><span style={{ fontSize: '100', color: '#1434CB' }}>{reward}</span><span style={{ fontSize: '46px', color: '#1434CB' }}>{language?.static_labels.yen}</span></h2>
                            <h5 style={{ textAlign: 'right', marginRight: '70px', fontSize: '32px' }}>{language?.static_labels.you_have_won}</h5>
                        </div>
                        <div className="col-md-4"></div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-lg-3"></div>
                <div className="col-lg-6">
                    <img src={congratsImage} alt="Congratulations" />
                </div>
                <div className="col-lg-3"></div>
            </div>
        </div>
        <div style={{ backgroundColor: 'white' }}>
            <br />
            <div className="align-center">
                <div class="container text-center">
                    <div>
                        <span style={{ color: '#1434CB', marginRight: '20px', fontSize: '22px' }}>{language?.static_labels.share_on_social_media}</span>
                        <InstagramShareButton imageUrl={imageUrl} reward={reward} chances={chances} campaignId={campaignId} congratsImage={congratsImage} tnxId={tnxId} />
                        <TwitterShareButton imageUrl={imageUrl} reward={reward} chances={chances} campaignId={campaignId} congratsImage={congratsImage} tnxId={tnxId} />
                    </div>
                </div>
            </div>
            <br/>
            <div className="row align-center font-11 margin-20">
                <div className="col-md-3"></div>
                <div className="col-md-6" style={{fontSize: '16px'}}>{language?.static_labels.wining_desc}</div>
                <div className="col-md-3"></div>
            </div>
            <br />
            <div style={{fontSize: '20px'}} className="align-center">
                <span>{language?.static_labels.you_have}</span><span> {chances - 1} </span><span>{language?.static_labels.remaining_spin}</span>
            </div>
            <br />
            <div className="align-center">
                {chances <= 1 ? <button style={{
                    paddingLeft: '10px',
                    backgroundColor: '#cccccc', color: '#666666'
                }} className="btn-bg-con" onClick={null}>
                    <img style={{ float: 'left' }} width={25} src={require('../../images/btn-img-dsbl.png')} alt="pointer" />
                    <span style={{ textAlign: 'center' }} >{language?.static_labels.play_again}</span>
                </button> :
                    <button style={{ paddingLeft: '10px', backgroundColor: '#1434CB' }} className="btn-bg-con" onClick={onSpin}>
                        <img style={{ float: 'left' }} width={25} src={require('../../images/btn-img.png')} alt="pointer" />
                        <span style={{ color: 'white', textAlign: 'center' }} >{language?.static_labels.play_again}</span>
                    </button>
                }
            </div>
            <br />
        </div>
    </div>
}